<template>
    <div id="social-media" class="animation-start">
        <div id="facebook">
            <a href="https://www.facebook.com/kisigodssingingkids" target="_blank">
                <img src="../../assets/img/social/facebook.png">
            </a>
        </div>
        <div id="youtube">
            <a href="https://www.youtube.com/user/KISIGodssingingkids" target="_blank">
                <img src="../../assets/img/social/youtube.png">
            </a>
        </div>
        <div id="kisi-logo">
            <a href="https://kisi.org" target="_blank">
                <img src="../../assets/img/social/kisi.png">
            </a>
        </div>
    </div>
</template>

<script>
export default {
  name: "social-media"
};
</script>

<style lang="scss">
@import "../../assets/scss/var";

#social-media {
  position: fixed;
  right: 0;
  top: 50%;
  height: 160px;

  @include media-small {
    display: none;
  }

  #facebook, #youtube, #kisi-logo {
    height: 50px;
    width: 50px;

    img {
      width: 100%;
      height: 100%;
    }
  }

  #facebook {
    background-color: #3b5998;
    margin-bottom: 5px;
  }

  #youtube {
    background-color: #e62d27;
    margin-bottom: 5px;
  }

  #kisi-logo {
    background-color: #fff;
    padding: 8px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/GlobalSegments/SocialMedia.vue